import Api from "@/services/Api";

export default {
  addProduct(params) {
    return Api().post("products", params);
  },

  addProductv2(params) {
    return Api().post("products-v2", params);
  },

  addProductGroup(params) {
    return Api().post("product-group", params);
  },

  getProductByName(params) {
    return Api().get("patterns/" + params.id);
  },

  getPhotoProductByName(params) {
    return Api().get("photo-patterns/" + params.id);
  },

  createCustomLineItems(params) {
    return Api.post("custom-line-items", params);
  },

  updatePatternOrder(params) {
    return Api.post("update-pattern-order", params);
  }
};



// WEBPACK FOOTER //
// ./src/services/ProductsService.js